import Layout from "src/components/Layout";
import logo from "../../images/DOTMEDICA.png";
import "./AboutPage.css";
import { useIsMobile } from "src/hooks/useIsMobile";

const AboutPage = () => {
  const { isMobile } = useIsMobile();

  return (
    <Layout hideMenuLogo={isMobile}>
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "center",
          alignSelf: "center",
        }}
      >
        <div className="about-c-container">
          <div className="about-c-image-section">
            <img src={logo} alt={logo} className="about-c-image" />
          </div>

          <div className="about-c-card">
            {!isMobile && (
              <div className="about-c-card-decoration">
                <div className="about-c-card-circle" />
                <div className="about-c-card-line" />
              </div>
            )}
            <div className="about-c-content">
              <div className="about-details">
                <p>
                  <strong>DOTMEDICA</strong> stands as a prominent occupational
                  medical center, both in the Middle East and globally.
                </p>
                <p>
                  <strong>DOTMEDICA</strong> has a motivated team of
                  professionals dedicated to providing high quality services
                  tailored to the requirements of our clients. It has extensive
                  experience in providing medical assessment for all ofshore,
                  onshore, maritime, and diving workers by approved and highly
                  qualified medical staf in a fully equipped clinic. Also,
                  medical consultations for all diving activities either
                  commercial or recreational and hyperbaric therapy. In
                  addition, it provides pre and annual employment medical
                  fitness assessment to many clients all over the world.
                  Finally, it ofers health and safety courses created for those
                  responsible for managing risk at work sites according to the
                  latest HSE and ASHI guidelines.
                </p>
                <p>
                  <strong>DOTMEDICA</strong> is a leading medical center that
                  provides all services also ONSITE to the companies with
                  time-pressured staf.
                </p>
                <p>
                  The story never stops here, <strong>DOTMEDICA</strong> always
                  looking forward to being a pioneer in the diving industry,{" "}
                  <strong>DOTMEDICA</strong> established Three Hyperbaric
                  Chambers, to serve the diving industry along the Red Sea
                  Shore, under a new brand <strong>DECO WORLD</strong>.
                </p>
                <p>
                  <strong>DOTMEDICA</strong> always strives toward excellence
                  and partnership with many occupational medical centers around
                  the world. <strong>DOTMEDICA</strong> is the exclusive medical
                  provider in <strong>Egypt</strong> for many of these medical
                  centers and companies in{" "}
                  <strong>UK, KSA, Dubai, Abu Dhabi and Malaysia.</strong>
                  This collaboration is poised to pave the way for a promising
                  future in the field of occupational medicine in the Middle
                  East.
                </p>
                <p>
                  We work with clients all over the world. If you think our
                  services could help you and your organization, please don’t
                  hesitate to contact us. We believe in ofering a great service
                  by ensuring we always put people and their business first. We
                  are confident that our price cannot be matched for the service
                  we ofer.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default AboutPage;
